import {
  AddAlert,
  BabyChangingStation,
  Build,
  CalendarToday,
  Celebration,
  ChildCare,
  ConfirmationNumber,
  GroupWork,
  List,
  MonetizationOn,
  School,
  SettingsApplications,
  AccountCircle,
} from '@mui/icons-material';

export const dashboardPaths = [
  {
    name: '/partners/create',
    title: 'Criação de parceiros',
    icon: GroupWork,
  },
  {
    name: '/partners/update',
    title: 'Edição de parceiros',
    icon: Build,
  },
  {
    name: '/partner-invites/create',
    title: 'Criação de convites',
    icon: ConfirmationNumber,
  },
  {
    name: '/partner-invites/update',
    title: 'Edição de convites',
    icon: SettingsApplications,
  },
  {
    name: '/universities',
    title: 'Universidades',
    icon: School,
  },
  {
    name: '/broadcast/schedule',
    title: 'Notificações',
    icon: AddAlert,
  },
  {
    name: '/broadcast/calendar',
    title: 'Calendário de Notificações',
    icon: CalendarToday,
  },
  {
    name: '/events/create',
    title: 'Criação/edição de eventos',
    icon: Celebration,
    roles: [1],
  },
  {
    name: '/ucoins',
    title: 'Ucoins',
    icon: MonetizationOn,
    roles: [1],
  },
  {
    name: '/issue-list',
    title: 'Lista de Tickets',
    icon: List,
    roles: [1],
  },
  {
    name: '/issue-details',
    title: 'Detalhes do Usuário',
    icon: AccountCircle,
    roles: [1],
  },
  {
    name: '/ubaby-list',
    title: 'Lista de Ubabies',
    icon: ChildCare,
    roles: [1],
  },
  {
    name: '/ubaby-details',
    title: 'Detalhes do Ubaby',
    icon: BabyChangingStation,
    roles: [1],
  },
];
